module.exports = require("ramda");


/*****************
 ** WEBPACK FOOTER
 ** external "ramda"
 ** module id = 9
 ** module chunks = 0
 **/